// extracted by mini-css-extract-plugin
export default {"scrollbar":"_1OnQb","visible":"_1Rxso","thumb":"vhdAj"};